import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export const CountUp = ({ value, className = "", duration = 1400 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const match = String(value).match(/^(\d+)(.*)$/s);
  const target = match ? parseInt(match[1], 10) : 0;
  const suffix = match ? match[2] : value;
  const isNumeric = !!match;
  const [n, setN] = useState(0);
  const hasRun = useRef(false);

  useEffect(() => {
    if (!inView || !isNumeric || hasRun.current) return;
    hasRun.current = true;
    let start = null;
    let raf;
    const step = (t) => {
      if (start === null) start = t;
      const p = Math.min((t - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * target));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, isNumeric, target, duration]);

  return (
    <span ref={ref} className={className}>
      {isNumeric ? `${n}${suffix}` : value}
    </span>
  );
};
